// extracted by mini-css-extract-plugin
export var body = "_dx-0";
export var sectionHeader = "_dx-4";
export var shortcutColumns = "_dx-2";
export var shortcutList = "_dx-1";
export var shortcutSection = "_dx-3";